import { SWITCH_TYPE, TEXT_TYPE } from "../../constants/webapp";

export const usePaymentMethodsForm = () => {
  const formFields = [
    {
      label: "Message",
      type: TEXT_TYPE,
      required: true,
      props: {
        rows: 4,
      },
    },
    {
      label: "Cash Delivery",
      id: "cash_delivery",
      type: SWITCH_TYPE,
    },
    {
      label: "Mobile Money",
      type: SWITCH_TYPE,
    },
  ];
  return { formFields };
};
